import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Col, FormGroup, Checkbox } from 'react-bootstrap'
import autobind from 'autobind-decorator'
import { pricePanelFields } from '../constants'
import { getObjVal } from '../utils'
import { getObjFromCache } from '../redux/stateUtils'
import { reduxForm, change as changeFieldValue } from 'redux-form'
import Input from '../components/elements/input'

@autobind
class PricePanel extends Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    numDays: PropTypes.number.isRequired,
    pricePerDay: PropTypes.number.isRequired
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.fields) {
      localStorage.removeItem('pricePanel')
      prevProps.fields
        ? localStorage.setItem(
            'pricePanel',
            JSON.stringify({
              comment: getObjVal(prevProps.fields.comment),
              customAmount: getObjVal(prevProps.fields.customAmount),
              useCustomAmount: getObjVal(prevProps.fields.useCustomAmount)
            })
          )
        : null
    }
  }

  updateCustomPriceField(onChange, value, listingIndex, roomIndex) {
    onChange(value)
    if (value && !value.target.checked) {
      this.props.dispatch(changeFieldValue('pricePanel', 'customAmount', 0))
    }
  }

  // Updates the customPrice in pricePanel form
  updateCustomPrice(onChange, value, listingIndex, roomIndex) {
    onChange(value)
    if (value && value.target.value) {
      this.props.dispatch(
        changeFieldValue(
          'pricePanel',
          'customAmount',
          parseFloat(value.target.value)
        )
      )
    }
  }

  render() {
    let {
      auth: { authenticated },
      numDays,
      pricePerDay,
      fields: { useCustomAmount, customAmount }
    } = this.props
    let totalPrice = pricePerDay * numDays
    // If isCustomPrice checkbox is checked then totalPrice will be taken from customAmount
    if (useCustomAmount.checked) {
      totalPrice = customAmount.value === '' ? 0 : customAmount.value
    }
    return (
      <Col md={12}>
        <strong>Number of days: </strong>
        {numDays}
        <br />
        <strong>Price per day: </strong>${pricePerDay}
        <br />
        <strong>Total price: </strong>${totalPrice}
        <br />
        {authenticated ? (
          <FormGroup>
            <Checkbox
              {...useCustomAmount}
              onChange={value => {
                this.updateCustomPriceField(useCustomAmount.onChange, value)
              }}
              value={useCustomAmount || false}
              style={{ float: 'left' }}
            >
              Use Custom Price
            </Checkbox>
          </FormGroup>
        ) : (
          ''
        )}
        {authenticated ? (
          <Input
            {...customAmount}
            value={getObjVal(useCustomAmount) ? getObjVal(customAmount) : 0}
            onChange={value => {
              this.updateCustomPrice(customAmount.onChange, value)
            }}
            type='number'
            standalone
            style={{ float: 'left' }}
            disabled={
              useCustomAmount && useCustomAmount.value ? undefined : true
            }
          />
        ) : (
          ''
        )}
      </Col>
    )
  }

  componentWillMount() {
    let {
      history: { prevPage }
    } = this.props
    if (prevPage != 'PAYMENT' && prevPage != '') {
      // This block is to set the custom payment form fields to its default values
      this.props.dispatch(changeFieldValue('pricePanel', 'customAmount', 0))
      this.props.dispatch(
        changeFieldValue('pricePanel', 'useCustomAmount', false)
      )
      this.props.dispatch(changeFieldValue('pricePanel', 'comment', ''))
    }
  }
}

// Which props do we want to inject, given the global state?
function selectProps(state) {
  return {
    auth: state.common.authentication,
    history: state.common.history
  }
}
function defaultValues() {
  let initValues = {
    useCustomAmount: false,
    customAmount: 0
  }
  let pricePanelFromCache = getObjFromCache('pricePanel')
  if (pricePanelFromCache) {
    initValues.useCustomAmount = pricePanelFromCache.useCustomAmount
      ? pricePanelFromCache.useCustomAmount
      : false
    initValues.customAmount = pricePanelFromCache.customAmount
      ? pricePanelFromCache.customAmount
      : 0
    initValues.comment = pricePanelFromCache.comment
      ? pricePanelFromCache.comment
      : ''
  }
  return initValues
}
export default reduxForm(
  {
    form: 'pricePanel',
    fields: pricePanelFields,
    initialValues: defaultValues(),
    destroyOnUnmount: false
  },
  selectProps
)(PricePanel)



// WEBPACK FOOTER //
// ./src/components/pricePanel.js